export default theme => ({

  root: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    'align-items': 'center',
    'justify-content': 'center'
  }

});






// WEBPACK FOOTER //
// ./src/styles/components/Loading.js